import { format } from "date-fns";

export const getFormatedDateAndTime = (date: string | undefined) => {
  return {
    date: date ? format(new Date(date), "EEE MMM dd, yyyy") : "",
    time: date ? format(new Date(date), "hh:mm aaa") : "",
  };
};

export const getReschedulingTitle = (
  originalAppointmentData: any,
  rescheduledAppointmentData: any
) => {
  const { date: originalDate, time: originalTime } = getFormatedDateAndTime(
    originalAppointmentData?.startDate
  );

  const { date: newDate, time: newTime } = getFormatedDateAndTime(
    rescheduledAppointmentData?.startDate
  );

  const showNewDate =
    newDate && (newDate !== originalDate || newTime !== originalTime);

  const newTimeTitle = ` to ${newDate} ${newTime}`;

  return `Rescheduling appointment from ${originalDate} ${originalTime}${
    showNewDate ? newTimeTitle : ""
  }`;
};
